import { clsx } from 'clsx';

import { BigSaleTotalDiscountAmount } from '~/app/common/components/Product/ProductPrice/BigSaleTotalDiscountAmount';
import { MembershipTotalDiscountAmount } from '~/app/common/components/Product/ProductPrice/MembershipTotalDiscountAmount';
import type { ProductPriceProps } from '~/app/common/components/Product/ProductPrice/index';
import { IS_BIG_SALE } from '~/domains/plusMembership/constants';

export function MembershipDiscountedPrice({
  price,
  productType,
  totalDiscountedPrice,
  totalDiscountAmount,
  className,
  wFull = true,
  is3x2 = false,
}: ProductPriceProps) {
  const isECoupon = productType === 'E_COUPON';

  if (!totalDiscountAmount) {
    return (
      <p
        className={clsx('mt-4 text-gray-1400', className)}
        style={{ fontSize: '16px', fontWeight: '700', lineHeight: '20px' }}
      >
        {price === 0 ? '상담신청 상품' : `${price.toLocaleString()}원`}
      </p>
    );
  }

  return (
    <div className={className}>
      <div className="text-description typo-footnote300-regular">
        {price.toLocaleString()}원
      </div>
      <div>
        <div className="text-membershipBlue-text typo-footnote300-semibold">
          나의할인가
        </div>
        <div
          className="text-membershipBlue-text"
          style={
            is3x2
              ? {
                  fontSize: 14,
                  fontWeight: 700,
                  lineHeight: '18px',
                }
              : { fontSize: '16px', fontWeight: '700', lineHeight: '20px' }
          }
        >
          {totalDiscountedPrice?.toLocaleString()}원
        </div>
      </div>
      {!isECoupon &&
        (IS_BIG_SALE ? (
          <BigSaleTotalDiscountAmount
            totalDiscountAmount={totalDiscountAmount}
            wFull={wFull}
            is3x2={is3x2}
          />
        ) : (
          <MembershipTotalDiscountAmount
            totalDiscountAmount={totalDiscountAmount}
            wFull={wFull}
            is3x2={is3x2}
          />
        ))}
    </div>
  );
}
